export default __webpack_public_path__ + "static/media/resume.c9fe4231.pdf";